import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useSendOtp = () => {
  const { apiClient } = useContext(OrderContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendOtp = async (orderNumber, email) => {
    if (!orderNumber || !email) {
      setError('Sipariş numarası ve e-posta adresi gereklidir.');
      return false;
    }

    setLoading(true);
    setError(null);

    try {
      await apiClient.post('api/v1/refund/send_otp/', {
        order_number: orderNumber,
        email: email,
      });
      return true;
    } catch (err) {
      let msg = 'OTP gönderilirken bir hata oluştu.';
      
      if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
        msg = 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.';
      } else if (err?.response?.data?.error) {
        msg = err.response.data.error;
      } else if (err.message) {
        msg = err.message;
      }
      
      setError(msg);
      // console.error('[useSendOtp] Error:', err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { sendOtp, loading, error };
};

export default useSendOtp;

